import Rebase from "re-base";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

const config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  clientId: process.env.REACT_APP_CIENT_ID,
  apiRoot: process.env.REACT_APP_API_ROOT,
};

const apiKey = config.apiKey;
const app = firebase.initializeApp(config);
const firestore = app.firestore();
const base = Rebase.createClass(firestore);

const storage = app.storage();
const googleProvider = new firebase.auth.GoogleAuthProvider();

export { config, apiKey, app, storage, base, googleProvider, firestore };
